import { displayDateFormat } from "../date-without-time";
import { format } from "date-fns"

export function formatDateTimeForDisplay(date?: Date | null) {
    if (!date) return "";
    return format(date!, displayDateFormat + " HH:mm");
}
